<content *ngIf="fieldData && fieldConfig">
  <eidos-input-boolean [input-class]="'eidos-field'" [disabled]="true" [(value)]="fieldData[fieldConfig.name]"></eidos-input-boolean>
</content>
